import { 
    Component, 
    ViewChild, 
    TemplateRef, 
    ViewEncapsulation
}  from "@angular/core";

import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { SelectionType } from "@swimlane/ngx-datatable";
import { fuseAnimations } from "@fuse/animations";
import { BaseComponent } from "../../base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { ParametroService } from "../services/parametro.service";
import { SessaoService } from "app/base-module/base-service/sessao.service";
import { IdleTimeoutService } from "app/base-module/base-service/idle-timeout.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: "app-lista-parametro",
    templateUrl: "./lista-parametro.component.html",
    styleUrls: ["./lista-parametro.component.scss"],  
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})

export class ListaParametroComponent extends BaseComponent{

    user:any;
    SelectionType = SelectionType;

    selected = [];
    data:any = {};
    titulo!:string;
    
    model:any = {        
    };

    vlr_min_boleta_sw           = new FormControl();
    vlr_min_primeira_boleta_sw  = new FormControl();
    vlr_min_boleta_fop          = new FormControl();
    vlr_min_primeira_boleta_fop = new FormControl();
    pertual_min_sinte = new FormControl();
    texto_notificacao_operacao = new FormControl();
    texto_notificacao_operacao_informativo = new FormControl();
    percentual_max_custodia = new FormControl();
    percentual_max_custodia_setor = new FormControl();
    percentual_marcao_mercado_rv = new FormControl();
    vlr_minimo_divisao_ativo_rv = new FormControl();

    // PROSP-594: janela de inatividade da sessao. So aparece/edita para quem tem
    // a permissao "Configurar Tempo de Sessao" (mesma exigida no backend).
    readonly PERMISSAO_SESSAO = "Configurar Tempo de Sessão";
    podeConfigurarSessao = false;
    idle_timeout_minutes = new FormControl();

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;

    constructor(public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private route: Router,
                private _authService: AuthService,
                private _service: ParametroService,
                private _sessaoService: SessaoService,
                private _idleTimeout: IdleTimeoutService)
    {

        super(dialog, snackBar);
        const strUser = this._authService.getUser();
this.user = JSON.parse(strUser? strUser : "{}");
        this.getAll();

        this.podeConfigurarSessao = this._authService.isPermissao([this.PERMISSAO_SESSAO]);
        if (this.podeConfigurarSessao) {
            this.carregarSessao();
        }
    }
    
    /**
     * Consulta lista de Boletas
     */
    getAll() {
        
        this._service.getAll(this.params).subscribe(
            data => {
                for(const dados of data.data){
                    
                    if(dados.codigo == "VALOR_MIN_BOLETA_SWING"){
                        this.vlr_min_boleta_sw.setValue(parseFloat(dados.valor));
                    }

                    if(dados.codigo == "VALOR_MIN_PRIMEIRA_BOLETA_SWING"){
                        this.vlr_min_primeira_boleta_sw.setValue(parseFloat(dados.valor));
                    }

                    if(dados.codigo == "VALOR_MIN_BOLETA_FOP"){
                        this.vlr_min_boleta_fop.setValue(parseFloat(dados.valor));
                    }

                    if(dados.codigo == "VALOR_MIN_PRIMEIRA_BOLETA_FOP"){
                        this.vlr_min_primeira_boleta_fop.setValue(parseFloat(dados.valor));
                    } 
                    
                    if(dados.codigo == "PERCENTUAL_MIM_GANHO_SINTETICO"){
                        this.pertual_min_sinte.setValue(parseFloat(dados.valor));
                    } 

                    if(dados.codigo == "MENSAGEM_NOTIFIC_OPERACAO"){
                        this.texto_notificacao_operacao.setValue(dados.valor);
                    } 

                    if(dados.codigo == "MENSAGEM_NOTIFIC_OPERACAO_INFORMATIVO"){
                        this.texto_notificacao_operacao_informativo.setValue(dados.valor);
                    }

                    if(dados.codigo == "PERCENTUAL_MAXIMO_CUSTODIA"){
                        this.percentual_max_custodia.setValue(dados.valor);
                    }

                    if(dados.codigo == "PERCENTUAL_MAXIMO_CUSTODIA_SETOR"){
                        this.percentual_max_custodia_setor.setValue(dados.valor);
                    }

                    if(dados.codigo == "RV_VLR_MINIMO_GERADOR_ORDEM_DIVICAO_ATIVO"){
                        this.vlr_minimo_divisao_ativo_rv.setValue(dados.valor);
                    }

                    if(dados.codigo == "RV_VLR_PERCENTUAL_GERADOR_MARCAO_MERCADO_ATIVO"){
                        this.percentual_marcao_mercado_rv.setValue(dados.valor);
                    }
                }               
            },
            error => {                
                this.loadingIndicator = false;
            },
            () => {                
                this.loadingIndicator = false;
            }
        );
    }

    openVisualizar(id:number){
        this.route.navigate(["/renda-variavel/basket-ativos/" + id]);
    }

    openAlterar(id:number){
        this.route.navigate(["/renda-variavel/basket-ativos/" + id]);
    }    

    salvar(){
        this.openLoading();
        
        this.model.VALOR_MIN_BOLETA_SWING = this.vlr_min_boleta_sw.value;
        this.model.VALOR_MIN_PRIMEIRA_BOLETA_SWING = this.vlr_min_primeira_boleta_sw.value;
        this.model.VALOR_MIN_BOLETA_FOP = this.vlr_min_boleta_fop.value;
        this.model.VALOR_MIN_PRIMEIRA_BOLETA_FOP = this.vlr_min_primeira_boleta_fop.value;
        this.model.PERCENTUAL_MIM_GANHO_SINTETICO = this.pertual_min_sinte.value;
        this.model.MENSAGEM_NOTIFIC_OPERACAO = this.texto_notificacao_operacao.value;
        this.model.MENSAGEM_NOTIFIC_OPERACAO_INFORMATIVO = this.texto_notificacao_operacao_informativo.value;
        this.model.PERCENTUAL_MAXIMO_CUSTODIA = this.percentual_max_custodia.value;
        this.model.PERCENTUAL_MAXIMO_CUSTODIA_SETOR = this.percentual_max_custodia_setor.value;
        this.model.RV_VLR_PERCENTUAL_GERADOR_MARCAO_MERCADO_ATIVO = this.percentual_marcao_mercado_rv.value;
        this.model.RV_VLR_MINIMO_GERADOR_ORDEM_DIVICAO_ATIVO = this.vlr_minimo_divisao_ativo_rv.value;

        this._service.update(this.model).subscribe(
            data => {
                this.closeLoading();
                this.showSuccess(data.message);
            },
            error => {
                this.closeLoading();
                this.showError(error.error.message);
            },
            () => {
                this.closeLoading();
            }
        );

    }

    /**
     * PROSP-594: carrega o tempo de inatividade efetivo (minutos) no campo.
     * O GET e livre para autenticados; a edicao e que exige permissao.
     */
    carregarSessao() {
        this._sessaoService.getIdleTimeout().subscribe(
            (data: any) => {
                if (data?.data?.minutes != null) {
                    this.idle_timeout_minutes.setValue(data.data.minutes);
                }
            },
            () => { /* mantem o campo vazio; nao bloqueia a tela */ }
        );
    }

    /**
     * PROSP-594: salva o tempo de inatividade. Valida 5..1440 tambem aqui (a UI
     * nao substitui a validacao do backend, so evita ida inutil). Restrito a
     * quem tem a permissao — o backend reforca com 403.
     */
    salvarSessao() {
        const minutos = Number(this.idle_timeout_minutes.value);

        if (!Number.isInteger(minutos) || minutos < 5 || minutos > 1440) {
            this.showError("Informe um tempo de inatividade inteiro entre 5 e 1440 minutos.");
            return;
        }

        this.openLoading();
        this._sessaoService.updateIdleTimeout(minutos).subscribe(
            (data: any) => {
                this.closeLoading();
                this.showSuccess(data?.message ?? "Tempo de inatividade atualizado com sucesso.");
                // Aplica na propria sessao do admin sem esperar o poll.
                this._idleTimeout.refreshConfig();
            },
            (error: any) => {
                this.closeLoading();
                this.showError(error?.error?.message ?? "Não foi possível atualizar o tempo de inatividade.");
            },
            () => {
                this.closeLoading();
            }
        );
    }

}
